const faqs = [
    {
        id: 1,
        heading: 'faqs.item1.heading',
        content: 'faqs.item1.content',
    },
    {
        id: 2,
        heading: 'faqs.item2.heading',
        content: 'faqs.item2.content',
    },
    {
        id: 3,
        heading: 'faqs.item3.heading',
        content: 'faqs.item3.content',
    },
    {
        id: 4,
        heading: 'faqs.item4.heading',
        content: 'faqs.item4.content',
    },
];

export default faqs;